export default __webpack_public_path__ + "static/media/use_action_back_cz.2b7816b9.png";